import _ from "lodash";

export default {
    methods: {
        pluck(array, key) {
            return array.map(o => o[key]);
        },
        getRiskStructureShort(riskStructure) {
            switch (riskStructure) {
                case 'accepted_declaration': return 'AD';
                case 'standalone_policy': return 'SP';
                case 'manual_submission_tracker': return 'MST';
                default: return '/';
            }
        },
        getRiskStructurePretty(riskStructure) {
            return _.startCase(riskStructure.replaceAll('_', ' '));
        }
    }
}
